export default __webpack_public_path__ + "static/media/oncology1.e55f2923.jpg";